import {FLink} from "../../components/other/FurtherLinks";
import {blogImg, linkedInImg, magazineImg, newspaperImg, radioImg} from "../imgLinks";

export const precysePresse: FLink[] = [
    {
        text: "NW",
        img: newspaperImg,
        linktitle: "Bielefelder Wissenschaftler im Kampf gegen Mukoviszidose",
        url: "https://www.nw.de/lokal/bielefeld/mitte/23937853_Bielefelder-Wissenschaftler-im-Kampf-gegen-Mukoviszidose.html"
    },
    {
        linktitle: "Studierende forschen an Gentherapie für Mukoviszidose",
        url: "https://blogs.uni-bielefeld.de/blog/pressemitteilungen/entry/studierende-forschen-an-gentherapie-f",
        text: "BIS-Blog",
        img: blogImg
    },
    {
        text: "Hertz",
        img: radioImg,
        linktitle: "Forschungspreis für Bielefelder Studierendenteam",
        url: "https://www.hertz879.de/nachrichten/forschungspreis-fuer-bielefelder-studierendenteam/"
    },
    {
        text: "Westfahlen Blatt",
        img: newspaperImg,
        linktitle: "Therapieansatz für Mukoviszidose: Vier Preise gehen nach Bielefeld",
        url: "https://www.westfalen-blatt.de/owl/bielefeld/therapieansatz-fuer-mukoviszidose-vier-preise-gehen-nach-bielefeld-3189405"
    },
    {
        text: "Ostwestfahlen",
        img: linkedInImg,
        linktitle: "Mukoviszidose behandeln: Uni Bielefeld gewinnt vier Preise in Paris",
        url: "https://www.linkedin.com/posts/ostwestfalen_studierende-forschen-an-gentherapie-für-mukoviszidose-activity-7259834308918407169-mwQ8/"
    },
    {
        linktitle: "Bielefelder Studierende revolutionieren Gentherapie gegen Mukoviszidose!",
        text: "Nachrichten Österreich",
        img: newspaperImg,
        url: "https://die-nachrichten.at/deutschland/nordrhein-westfalen/bielefeld/bielefelder-studierende-revolutionieren-gentherapie-gegen-mukoviszidose/"
    },
    {
        linktitle: "Vierfach Gold für Bielefelder iGEM-Team",
        img: blogImg,
        url: "https://blogs.uni-bielefeld.de/blog/pressemitteilungen/entry/vierfach-gold-f-uuml-r",
        text: "BIS-Blog"
    },
    {
        text: "Bio Spektrum",
        img: magazineImg,
        linktitle: "iGEM-Teams aus Aachen, Wien, Münster, Heidelberg, Marburg und Bielefeld",
        url: "https://www.biospektrum.de/magazinartikel/igem-teams-aus-aachen-wien-muenster-heidelberg-marburg-und-bielefeld"
    },
    {
        text: "CeBiTec Quarterly",
        url: "https://www.cebitec.uni-bielefeld.de/localmedia/downloads/quarterly/CeBiTec-Quarterly_2024-4.pdf",
        linktitle: "Quadruple gold for the iGEM team from Bielefeld-CeBiTec",
        img: magazineImg
    }
]

// facebook:
// https://www.facebook.com/BielefeldUniversity/posts/-ein-studentisches-interdisziplin%C3%A4res-forschungsteam-forscht-zu-einer-gentherapi/896435142494599/